import { Card } from '@iwoca/orion';
import { Skeleton } from '@ui';

export const PageContainer = ({
    children,
    ...props
}: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>) => {
    return (
        <div
            className="flex flex-col items-start gap-xl min-l:flex-row"
            {...props}
        >
            {children}
        </div>
    );
};

export const LoadingSkeleton = (
    props: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    >
) => {
    return (
        <PageContainer {...props}>
            <Card className="space-y-xl min-l:p-xl">
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
            </Card>
            <Card className="space-y-xl min-l:max-w-[375px] min-l:p-xl">
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
            </Card>
        </PageContainer>
    );
};
